module.exports = __webpack_public_path__ + "asset/image-Baby-dc7d0aeba04a5076.svg";


//////////////////
// WEBPACK FOOTER
// ./src/application/component/category-icon/image/Baby.svg
// module id = VID3
// module chunks = 0